import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useGetConfigFiltrosCultura(page: number, size: number, filters?: any) {
  return useQuery(
    [URL.OCUPACOES.OBTER, filters, page, size],
    async () => {
      const { data, headers } = await http.get<any, any>(URL.OCUPACOES.OBTER, {
        params: {
          ...filters,
          page,
          size,
        },
      });
      return { data, paginate: JSON.parse(headers.paginate) };
    },
    {
      keepPreviousData: true,
    }
  );
}

export default useGetConfigFiltrosCultura;
